import { Extension } from '@tiptap/core';

/**
 * Prevents backspace at the start of a block from merging its content into the preceding
 * non-textblock node (e.g. callouts, accordions, widgets, solvers, etc.).
 *
 * - If the current block is empty, it is deleted instead.
 * - If it has content, the backspace is simply blocked to prevent the merge.
 *
 * Textblock nodes (paragraph, heading, codeBlock) are excluded so that normal
 * join-backward behavior is preserved.
 */
export const PreventBlockMergeExtension = Extension.create({
  name: 'preventBlockMerge',

  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const { from, to, $from } = editor.state.selection;

        // If there's an active selection, let default deletion handle it
        if (from !== to) {
          return false;
        }

        // Only handle when cursor is at the very start of a block
        if ($from.parentOffset !== 0) {
          return false;
        }

        const resolvedPos = editor.state.doc.resolve($from.before());
        const nodeBefore = resolvedPos.nodeBefore;

        if (!nodeBefore || !nodeBefore.type.isBlock || nodeBefore.type.isTextblock) {
          return false;
        }

        // nodeBefore is a non-textblock block node — prevent merging into it
        if ($from.parent.content.size === 0) {
          // Current block is empty — delete it
          editor.chain().deleteRange({ from: $from.before(), to: $from.after() }).focus().run();
          return true;
        }

        return true;
      },
    };
  },
});
